import { isNil } from 'lodash';
import { DEFAULT_CHEVRON_PROPS } from '../../../../../Shape/config/Shapes';

const getTipWidth = shape => (isNil(shape.get('tipWidth')) ? DEFAULT_CHEVRON_PROPS.tipWidth : shape.get('tipWidth'));

export default getTipWidth;
